module.exports = __webpack_public_path__ + "static/lavado-manos-bfe888cd190309a834280b5b9c454cb9.png";